import {checkAppUrl} from '../../../js/features/common-page.ts';

export function initUserAuthSAML() {
  const outer = document.querySelector('#saml-login-navigator');
  if (!outer) return;
  const inner = document.querySelector('#saml-login-navigator-inner');
  if (!inner) return;

  checkAppUrl();

  for (const link of outer.querySelectorAll('.saml-login-link')) {
    link.addEventListener('click', () => {
      inner.classList.add('gt-invisible');
      outer.classList.add('is-loading');
      setTimeout(() => {
        // recover previous content to let user try again
        // usually redirection will be performed before this action
        outer.classList.remove('is-loading');
        inner.classList.remove('gt-invisible');
      }, 5000);
    });
  }
}
